<template>
  <v-app primary>
    <v-navigation-drawer clipped app light fixed
      v-model="drawer"
      v-if="user.authenticated && hasRole('evaluator')">
      <v-list dense two-line subheader>
        <v-subheader>Menu</v-subheader>
        <v-divider></v-divider>
        <v-list-tile v-for="item in enabledItems" :key="item.title" value="true" :to="item.to">
          <v-list-tile-action>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title color="warning" v-if="item.title==='Avaliar trabalho' && user.type==='4' " ><b>{{ item.title }}</b></v-list-tile-title>
            <v-list-tile-title color="warning" v-else-if="item.title==='Reservar materiais de informática'" @click="goToCAPI(user.id)" >{{ item.title }}</v-list-tile-title>
            <v-list-tile-title v-else>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="user.authenticated" value="true" @click="logout">
          <v-list-tile-action>
            <v-icon color="primary">exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed clipped-left app dark class="primary elevation-1" :dense="$vuetify.breakpoint.xsOnly">
      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        v-if="user.authenticated && hasRole('evaluator')"></v-toolbar-side-icon>
      <v-toolbar-title>
          <router-link to="/" class="brand"><img src="https://minha.unifebe.edu.br/sisbanca/imgs/logo-branca-bancas.png" style="width:150px"/></router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat to="/cronograma" exact title="Cronograma">
          <v-icon :left="!mobile" dark :class="!mobile ? 'mr-2' : ''">today</v-icon><span class="hidden-sm-and-down"> Cronograma</span>
        </v-btn>               
        <v-btn flat to="/entrar" v-if="!user.authenticated">
          <v-icon left dark class="mr-2">power_settings_new</v-icon> Entrar
        </v-btn>
        <v-btn flat v-if="user.authenticated" :title="'Logado como ' + user.name + ' (' + user.id + ')'">
          <v-icon :left="!mobile" dark :class="!mobile ? 'mr-2' : ''">person</v-icon><span class="hidden-sm-and-down"> {{ user.name }} ({{ user.id }})</span>          
        </v-btn>
        <v-btn flat v-if="mobile && screenfull.enabled" @click="toggleFullscreen">
            <v-icon v-if="!isFullscreen">fullscreen</v-icon>
            <v-icon v-if="isFullscreen">fullscreen_exit</v-icon>
        </v-btn>
        <v-menu bottom left offset-y origin="bottom right" transition="v-slide-y-transition" v-if="user.authenticated || mobile">
          <v-btn icon dark slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <!-- <v-list-tile value="true" v-if="mobile"
              href="https://docs.google.com/document/d/e/2PACX-1vQ2l5UVEKKvagMuHak4p0qnVWNcbrY12Cx_9eZ8m9h6Gjl0Z6NTrgRz30ruicGAFn0anBkdPWVj7FMv/pub" target="_blank"> -->

            <v-list-tile value="true" v-if="mobile"
              href="https://docs.google.com/document/u/2/d/e/2PACX-1vRrFT6DklCW-ifgP9Fz3EmAGT2pJeppMqzjmsJNgV8jpEV5d0L9zWWWH7wQu4Rde1PihFPzFtBU8rRN/pub" target="_blank">
              <v-list-tile-action>
                <v-icon>help</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Ajuda</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>             
            <v-list-tile value="true" @click="logout" v-if="user.authenticated">
              <v-list-tile-action>
                <v-icon>exit_to_app</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Sair</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>           
          </v-list>
        </v-menu>
        <!--
        <v-btn flat title="Ajuda" v-if="!mobile"
          href="https://docs.google.com/document/d/e/2PACX-1vQ2l5UVEKKvagMuHak4p0qnVWNcbrY12Cx_9eZ8m9h6Gjl0Z6NTrgRz30ruicGAFn0anBkdPWVj7FMv/pub" target="_blank">
          <v-icon :left="!mobile" dark :class="!mobile ? 'mr-2' : ''">help</v-icon><span class="hidden-sm-and-down"> Ajuda</span>
        </v-btn>
        -->
        <v-btn flat title="Ajuda" v-if="!mobile"
          href="https://docs.google.com/document/u/2/d/e/2PACX-1vRrFT6DklCW-ifgP9Fz3EmAGT2pJeppMqzjmsJNgV8jpEV5d0L9zWWWH7wQu4Rde1PihFPzFtBU8rRN/pub" target="_blank">
          <v-icon :left="!mobile" dark :class="!mobile ? 'mr-2' : ''">help</v-icon><span class="hidden-sm-and-down"> Ajuda</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer fixed app dark class="primary hidden-sm-and-down">
      <span class="white--text">{{ footerText }}</span>
    </v-footer>
  </v-app>
</template>

<script>
  import auth from './auth'
  import package_settings from './../package.json'
  import screenfull from 'screenfull'

  export default {
    data() {
      return {
        drawer: true,
        footerText: package_settings.name + '-' + package_settings.version + '. ' + '© UNIFEBE 2017-'+new Date().getFullYear()+'. Todos os direitos reservados.',
        user: auth.user,
        token: "5b03885cf262c285ee3516d8e5df46ce",
        allItems: [          
          { icon: 'settings', title: 'Definições do curso', to: '/curso/configuracoes', role: 'examcoordinator|coursecoordinator' },
          { icon: 'schedule', title: 'Planejar banca', to: '/bancas/planejar', role: 'examcoordinator|coursecoordinator' },
          { icon: 'today', title: 'Cronograma público', to: '/cronograma', role: null },
          { icon: 'gavel', title: 'Avaliar trabalho', to: '/bancas/avaliar', role: 'evaluator' },
          { icon: 'school', title: 'Presidir banca', to: '/bancas/presidir', role: 'chair' },
          { icon: 'assignment', title: 'Consultar bancas', to: '/bancas', role: 'examcoordinator|coursecoordinator' },          
          { icon: 'class', title: 'Termos de publicização', to: '/bancas/termos', role: 'examcoordinator|coursecoordinator' },          
          { icon: 'info', title: 'Ver pendências', to: '/bancas/pendencias', role: 'examcoordinator|coursecoordinator' },          
          { icon: 'bookmark', title: 'Reservar materiais de informática', to: '/bancas', role: 'examcoordinator|coursecoordinator' },          
          // { icon: 'file_upload', title: 'Importar bancas', to: '/bancas/importar', role: 'examcoordinator|coursecoordinator' },          
          { icon: 'person_add', title: 'Cadastrar avaliador externo', to: '/avaliador/cadastrar', role: 'examcoordinator|coursecoordinator' }
        ],
        screenfull: screenfull,
        isFullscreen: false
      }
    },
    computed:  {
      title: function() {
        if (this.$vuetify.breakpoint.xsOnly) {
          return 'Bancas'
        } else {
          return 'Sistema de Gestão de Bancas'
        }
      },
      mobile: function() {
        return this.$vuetify.breakpoint.xsOnly
      },
      enabledItems: function() {
        return this.allItems.filter(item => {
          if (item.role != null) {            
            return item.role.split('|').some(role => {
              return this.hasRole(role)
            })
           } else {
            return true
          }
          return false
        })
      }      
    },
    methods: {
      goToCAPI(id) {  
        var win = window.open("https://www5.unifebe.edu.br/unifebe-plus/frontend/bancasParaCapi.php?cd_usuario="+id+"&token="+this.token, '_blank');  
        win.focus();
    },
      logout() { 
        this.$store.commit('setLastModifiedExam', false)
        auth.logout() 
      },
      hasRole(role) { 
        if (auth.user.authenticated && typeof auth.user.roles !== 'undefined') {
          return (auth.user.roles.includes(role) || auth.user.roles.includes('admin'))
        }
        return false
      },
      toggleFullscreen() {
        screenfull.toggle()        
      }
    },
    created() {
      this.$store.commit('setLastModifiedExam', false);
      var that = this
      screenfull.on('change', function() {
        that.isFullscreen = screenfull.isFullscreen
      })
    }
  }

</script>

<style lang="stylus">
  @import './stylus/main';
</style>

<style type="text/css">
  /* Old CSS code from vuetify v0.16, a fix for heading style */
  h1{font-size:112px;font-weight:300;line-height:1;letter-spacing:-.04em;margin-bottom:16px}@media screen and (max-width:600px){h1{font-size:67.2px}}h2{font-size:56px;font-weight:400;line-height:1.35;letter-spacing:-.02em;margin-bottom:16px}@media screen and (max-width:600px){h2{font-size:33.6px}}h3{font-size:45px;font-weight:400;line-height:48px;letter-spacing:normal;margin-bottom:16px}@media screen and (max-width:600px){h3{font-size:27px}}h4{font-size:34px;font-weight:400;line-height:40px;letter-spacing:normal;margin-bottom:16px}@media screen and (max-width:600px){h4{font-size:20.4px}}h5{font-size:24px;font-weight:400;line-height:32px;letter-spacing:normal;margin-bottom:16px}@media screen and (max-width:600px){h5{font-size:14.399999999999999px}}h6{font-size:20px;font-weight:500;line-height:1;letter-spacing:.02em;margin-bottom:16px}@media screen and (max-width:600px){h6{font-size:12px}}subheading{font-size:16px;font-weight:400;margin-bottom:16px}
  ol,ul{padding-left:24px}
  .navigation-drawer>.list .list__tile{color:rgba(0,0,0,.87);font-weight:400}
  /* Added for compatibility with v0.17 */
  .navigation-drawer>.list .list__tile.primary--text{color:rgba(0,0,0,.87) !important}
  .application--light .subheader, .application .theme--light.subheader {color: rgba(0,0,0,.87)}
  .theme--light .subheader, .application .theme--light.subheader {color: rgba(0,0,0,.87)}
</style>


// WEBPACK FOOTER //
// App.vue?285018db